import React, { useEffect, useState } from "react";

let timeout;

const ErrorAlert = ({ errorMessage, subErrorMessage, delay = 3000, showErr }) => {
    const [show, setShow] = useState(showErr);
    const [errMsg, setErrMsg] = useState("");

    useEffect(() => {
        setErrMsg(errorMessage);

        setTimeout(() => {
            setShow(true);

            timeout && clearTimeout(timeout);

            timeout = setTimeout(() => {
                setShow(false);
                setErrMsg("");
            }, delay);
        }, 500);

        return () => {
            setShow(false);
            setErrMsg("");
            clearTimeout(timeout);
        };
    }, [showErr, delay, errorMessage]);

    return (
        <div className={`error-message ${show ? "show" : ""}`}>
            <div className="error">
                <i className="fas fa-exclamation-triangle"></i> {errMsg}
            </div>

            <div>{subErrorMessage}</div>
        </div>
    );
};

export default ErrorAlert;
